"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = exports.Root = void 0;
var _react = require("@emotion/react");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const spin = (0, _react.keyframes)`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const Root = exports.Root = (0, _mui.styled)('div')(_constants.centeredFlexStyles);
const Spinner = exports.Spinner = (0, _mui.styled)(_icons.OriflameSpinner)({
  animation: `${spin} 1s linear infinite`
});
